import { memo } from 'react';

import { RefreshCwIcon } from '@air/design-icons';
import { cn } from '@air/utils-tailwind';

import { type FileStatusIconSize, fileStatusIcon, getFileStatusIconGlyphSize } from '../fileStatusIconSize';

export type FileStatusIconProgressingProps = {
  size?: FileStatusIconSize;
};

export const FileStatusIconProgressing = memo(({ size = 'default' }: FileStatusIconProgressingProps) => {
  const { container } = fileStatusIcon({ size });
  const glyphSize = getFileStatusIconGlyphSize(size);

  return (
    <div
      aria-hidden
      className={cn(
        'flex animate-spin items-center justify-center rounded-full ads:bg-ads-sky-5 bg-sky-5 motion-reduce:animate-none',
        container(),
      )}
    >
      <RefreshCwIcon className="ads:text-ads-sky-11 text-sky-11" size={glyphSize} />
    </div>
  );
});

FileStatusIconProgressing.displayName = 'FileStatusIconProgressing';
